import React, { useState, useEffect, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import ReportLayout, { ReportTable, usePagination, fmtId } from './ReportLayout';
import { ReportChartRow, BarCard, groupCount, groupByMonth } from './ReportCharts';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const fmtDT = v => { try { return v ? format(parseISO(v), 'd/MM/yyyy hh:mm a').toUpperCase() : '–'; } catch { return v||'–'; } };

const COLS = [
  { key:'shift_id',   label:'Shift ID', render: fmtId },
  { key:'expires',    label:'Expires',  render: fmtDT },
  { key:'client',     label:'Client',   render: v => <span className="text-primary-600">{v||'–'}</span> },
  { key:'price_book', label:'Price Book' },
  { key:'shift_type', label:'Shift Type' },
  { key:'_team',      label:'Team',     render: () => '–' },
  { key:'facility',   label:'Facility' },
  { key:'address',    label:'Address' },
];

export default function RecurringShiftExpiry() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStart] = useState(today);
  const [endDate, setEnd]     = useState(new Date(Date.now()+30*86400000).toISOString().split('T')[0]);
  const pagination = usePagination(data, 10);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/reports/recurring-shift-expiry?start_date=${startDate}&end_date=${endDate}`)
      .then(r => { setData(r.data||[]); pagination.reset(); })
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const chips = [{ label:'Date Range', value:`${startDate} - ${endDate}` }];

  return (
    <ReportLayout title="Recurring Shift Expiry" data={data} filename="recurring_shift_expiry"
      columns={COLS} activeChips={chips} showFiltersPanel={showFilters} onToggleFilters={() => setShowFilters(v=>!v)}
      chart={
        <ReportChartRow>
          <BarCard title="Expiring by month" data={groupByMonth(data, 'expires')} color="#F59E0B" />
          <BarCard title="By shift type" data={groupCount(data, 'shift_type')} color="#06B6D4" />
        </ReportChartRow>
      }
      filters={
        <div className="flex flex-wrap gap-4">
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Start Date</label>
            <input type="date" value={startDate} onChange={e => setStart(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">End Date</label>
            <input type="date" value={endDate} onChange={e => setEnd(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div className="flex items-end"><button onClick={load} className="btn-primary text-sm px-4 py-2">Apply</button></div>
        </div>
      }>
      <ReportTable columns={COLS} data={data} loading={loading} pagination={pagination}/>
    </ReportLayout>
  );
}
